import api from "@/api/axios";

const usuarioModel = {
    data: {
        name: null,
        email: null,
        password: null,
        passwordrepit: null,
        acepta_terminos: null,
        acepta_ddjj: null,

        perfil: {
            id: null,
            name: null,
            email: null,
            razon_social: null,
            cuit: null,
            direccion: null,
            provincia_id: null,
            ciudad: null,
            celular: null,
        }
    },

    async iniciarSesion(email, password) {
        try {
            const response = await api.post("/login", { email, password });
            return response.data;
        } catch (error) {
            console.error("Error en el inicio de usuario", error);
            throw error;
        }
    },

    async getSession() {
        try {
            const response = await api.get(`/get-session`);
            return response.data;
        } catch (error) {
            console.error("Error en obtener el usuario", error);
            throw error;
        }
    },

    async registrarUsuario(name, email, password) {
        try {
            const response = await api.post("/register", { name, email, password })
            return response.data;
        } catch (error) {
            console.error("Error en registrar usuario", error);
            throw error;
        }
    },

    async cerrarSesion() {
        try {
            await api.post(`/logout`);
        } catch (error) {
            console.error("Error al cerrar sesion de usuario", error);
            throw error;
        }
    },

    async confirmarLoginExterno({ token, session_id, id }) {
        try {
            const response = await api.post("/external-confirm-login", {
                token,
                session_id,
                id
            });
            return response.data;
        } catch (error) {
            console.error("Error al confirmar login externo", error);
            throw error;
        }
    },

    async obtenerPerfilesFacturacionUsuario(){
        try {
            return await api.get(`/usuarios/perfiles-facturacion`);
        } catch (error) {
            console.error("Error al obtener datos de Facturacion", error);
            throw error;
        }
    }

};

export default usuarioModel;